import { render, staticRenderFns } from "./material-upload-view.vue?vue&type=template&id=7a90bf2e&scoped=true"
import script from "./material-upload-view.vue?vue&type=script&lang=js"
export * from "./material-upload-view.vue?vue&type=script&lang=js"
import style0 from "./material-upload-view.vue?vue&type=style&index=0&id=7a90bf2e&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a90bf2e",
  null
  
)

export default component.exports